import type { Socket } from 'socket.io-client'

export const emitTotalUnreadNotifications = (socket: Socket) => {
  socket.emit('getTotalUnreadNotifications')
}
